import { html, type TemplateResult } from 'lit';

import type { FormAlert, Variant } from '../types/appointment-booking.types.js';
import { variantRegistry } from './variants.js';

interface AppointmentBookingFormTemplateParams {
    variant: Variant;
    lang: string;
    namePattern: string;
    emailPattern: string;
    newsletter: string;
    dataProtectionLink: string;
    formAlert?: FormAlert;
    onValidityChange: (event: Event) => void;
    onSubmit: (event: Event) => void;
}

export const renderAppointmentBookingFormTemplate = ({
    variant,
    ...rest
}: AppointmentBookingFormTemplateParams): TemplateResult => {
    const renderFn = variantRegistry[variant] || variantRegistry.default;

    return html` <div class="m-appointment-request">${renderFn(rest)}</div> `;
};
